import { put, call, takeLatest, select } from 'redux-saga/effects';
import { getZipCode } from 'yoda-interfaces/lib/Vendor/VendorApi';
import _isEmpty from 'lodash/isEmpty';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import {
    SET_AKAMAI_LOC_ZIPCODE,
    AKAMAI_LOC_ZIPCODE_SUCCESS,
    AKAMAI_LOC_ZIPCODE_ERROR,
    AKAMAI_LOC_ZIPCODE_INITIATE,
} from '../actionTypes/LocationActionTypes';
import {
    selectReqHeaders,
    selectAkamaiGeoCookie,
    selectAkamaiZipCookie,
    selectAkamaiZipCookieTTL,
    selectEnableAkamaiGeoZipCode,
} from '../selectors/ContextSelector';
import { getCookieOrLocalStorageData } from '../helpers/Utils/utils';

function* fetchGeoZipCode() {
    try {
        const akGeoCookie = yield select(selectAkamaiGeoCookie);
        const akZipCookie = yield select(selectAkamaiZipCookie);
        const akZipCookieTTL = yield select(selectAkamaiZipCookieTTL);
        const enableAkamaiGeoZipCode = yield select(selectEnableAkamaiGeoZipCode);
        let akZipcode = null;
        if (enableAkamaiGeoZipCode) {
            const reqHeaders = yield select(selectReqHeaders);
            const userLatLong = getCookieOrLocalStorageData(reqHeaders, akGeoCookie);
            const latLong = userLatLong?.split(',');
            akZipcode = getCookieOrLocalStorageData(reqHeaders, akZipCookie);
            /* istanbul ignore if */
            if (latLong?.length === 2 && _isEmpty(akZipcode)) {
                yield put({ type: AKAMAI_LOC_ZIPCODE_INITIATE });
                akZipcode = yield call(getZipCode, { latlng: userLatLong });
                if (akZipcode) {
                    const cookieTtl = akZipCookieTTL || 30;
                    Cookies.save(akZipCookie, akZipcode, cookieTtl / (60 * 24));
                    yield put({ type: AKAMAI_LOC_ZIPCODE_SUCCESS, akZipcode });
                } else {
                    const error = { errorMsg: 'Request for zipcode failed' };
                    yield put({ type: AKAMAI_LOC_ZIPCODE_ERROR, error });
                }
            } else {
                yield put({ type: AKAMAI_LOC_ZIPCODE_SUCCESS, akZipcode });
            }
        }
    } catch (error) {
        yield put({ type: AKAMAI_LOC_ZIPCODE_ERROR, error });
    }
}

const watchAkamaiZipcode = function* watchAkamaiZipcode() {
    yield takeLatest(SET_AKAMAI_LOC_ZIPCODE, fetchGeoZipCode);
};

watchAkamaiZipcode.sagaName = 'akamaiZipCodeSaga';

export default watchAkamaiZipcode;
